import React from "react";
import AutoFinishInProduction from "./Drawers/AutoFinishInProduction";
import BannersDrawer from "./Drawers/BannersDrawer";
import BlockedCustomers from "./Drawers/BlockedCustomers";
import BlockOrderInterval from "./Drawers/BlockOrderInterval";
import BlockProductSKU from "./Drawers/BlockProductSKU";
import BrandLogoDrawer from "./Drawers/BrandLogoDrawer";
import ConfirmLoginDrawer from "./Drawers/ConfirmLoginDrawer";
import ConfirmAddressDrawer from "./Drawers/ConfirmAddressDrawer";
import KMLPaymentDrawer from "./Drawers/KMLPaymentDrawer";
import PaymentAddressDrawer from "./Drawers/PaymentAddressDrawer";
import PaymentSwitchesDrawer from "./Drawers/PaymentSwitchesDrawer";
import ResetPassword from "./Drawers/ResetPassword";
import CustomerPermissionsDrawer from "./Drawers/CustomerPermissionsDrawer";

export const SystemDrawerTypes = {
  BANNERS: "BANNERS",
  BRAND_LOGO: "BRAND_LOGO",
  PAYMENT_SWITCHES: "PAYMENT_SWITCHES",
  AUTO_FINISH_IN_PRODUCTION: "AUTO_FINISH_IN_PRODUCTION",
  BLOCKED_CUSTOMERS: "BLOCKED_CUSTOMERS",
  BLOCK_PRODUCT_SKU: "BLOCK_PRODUCT_SKU",
  BLOCK_ORDER_INTERVAL: "BLOCK_ORDER_INTERVAL",
  BLOCK_PAYMENT_REGION: "BLOCK_PAYMENT_REGION",
  BLOCK_PAYMENT_ADDRESS: "BLOCK_PAYMENT_ADDRESS",
  CONFIRM_LOGIN: "CONFIRM_LOGIN",
  RESET_PASSWORD: "RESET_PASSWORD",
  CONFIRM_ADDRESS: "CONFIRM_ADDRESS",
  CUSTOMER_PERMISSION: "CUSTOMER_PERMISSION"
};

export class SystemSettingDrawer extends React.Component {
  state = {
    data: null,
  };

  onClose() {
    const { onClose } = this.props;
    this.setState({ data: null }, onClose);
  }

  render() {
    const { visible, setting, onSave, onClose } = this.props;

    switch (setting) {
      case SystemDrawerTypes.BANNERS:
        return (
          <BannersDrawer visible={visible} onSave={onSave} onClose={onClose} />
        );
      case SystemDrawerTypes.BRAND_LOGO:
        return (
          <BrandLogoDrawer
            visible={visible}
            onSave={onSave}
            onClose={onClose}
          />
        );
      case SystemDrawerTypes.PAYMENT_SWITCHES:
        return (
          <PaymentSwitchesDrawer
            visible={visible}
            onSave={onSave}
            onClose={onClose}
          />
        );
      case SystemDrawerTypes.AUTO_FINISH_IN_PRODUCTION:
        return (
          <AutoFinishInProduction
            visible={visible}
            onSave={onSave}
            onClose={onClose}
          />
        );
      case SystemDrawerTypes.BLOCKED_CUSTOMERS:
        return (
          <BlockedCustomers
            visible={visible}
            onSave={onSave}
            onClose={onClose}
          />
        );
      case SystemDrawerTypes.BLOCK_PRODUCT_SKU:
        return (
          <BlockProductSKU
            visible={visible}
            onSave={onSave}
            onClose={onClose}
          />
        );
      case SystemDrawerTypes.BLOCK_ORDER_INTERVAL:
        return (
          <BlockOrderInterval
            visible={visible}
            onSave={onSave}
            onClose={onClose}
          />
        );
      case SystemDrawerTypes.BLOCK_PAYMENT_REGION:
        return (
          <KMLPaymentDrawer
            visible={visible}
            onSave={onSave}
            onClose={onClose}
          />
        );
      case SystemDrawerTypes.BLOCK_PAYMENT_ADDRESS:
        return (
          <PaymentAddressDrawer
            visible={visible}
            onSave={onSave}
            onClose={onClose}
          />
        );
      case SystemDrawerTypes.CONFIRM_LOGIN:
        return (
          <ConfirmLoginDrawer
            visible={visible}
            onSave={onSave}
            onClose={onClose}
          />
        );
      case SystemDrawerTypes.RESET_PASSWORD:
        return (
          <ResetPassword
            visible={visible}
            onSave={onSave}
            onClose={onClose}
          />
        );
      case SystemDrawerTypes.CONFIRM_ADDRESS:
        return (
          <ConfirmAddressDrawer
            visible={visible}
            onSave={onSave}
            onClose={onClose}
          />
        );
      case SystemDrawerTypes.CUSTOMER_PERMISSION:
        return (
          <CustomerPermissionsDrawer
            visible={visible}
            onSave={onSave}
            onClose={onClose}
          />
        );
      default:
        return null;
    }
  }
}
